import React, { useEffect, useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import './Layout.css';
import { FaHome } from 'react-icons/fa';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {  getDoc,doc, onSnapshot, updateDoc, increment } from 'firebase/firestore';
import { auth,db } from './firebase';
import { setDoc } from 'firebase/firestore';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [tokens, setTokens] = useState(null); // null = loading
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [addingTokens, setAddingTokens] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    let unsubscribeTokens = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
        const uid = user.uid;
        const userDocRef = doc(db, 'user-data', uid);

        unsubscribeTokens = onSnapshot(userDocRef, (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            setUsername(data.username || '');
            setTokens(data.tokens !== undefined ? data.tokens : 0);
          } else {
            setUsername('');
            setTokens(0);
          }
        });
      } else {
        setIsAuthenticated(false);
        setUsername('');
        setTokens(0);
        if (unsubscribeTokens) unsubscribeTokens();
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeTokens) unsubscribeTokens();
    };
  }, []);

  const handleBuyMoreTokens = () => {
    navigate('/homepage/buy-packs');
  };

  // Securely add tokens safely (increment instead of replace)
const addTokens = async (amount) => {
  if (addingTokens) return;
  setAddingTokens(true);

  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not authenticated");

    // Get Firebase ID token for authentication
    const idToken = await user.getIdToken();

    const resp = await fetch("/api/add-tokens", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idToken, amount }),
    });

    const data = await resp.json();
    if (!data.success) throw new Error(data.error || "Failed to add tokens");

    console.log(`✅ Successfully added ${amount} tokens`);

    // UI auto-updates via onSnapshot, no need to manually increment
  } catch (err) {
    console.error("addTokens error:", err.message);
  } finally {
    setAddingTokens(false);
  }
};


  const pageVariants = {
    initial: { opacity: 0, x: 80 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -80 },
  };

  return (
    <>
      {/* Navbar */}
      <div className="navbar-wrapper">
        <nav className="navbar">
          <div className="nav-left">
            <div className="back-buttona" onClick={() => navigate('/')}>
              <span className="back-arrowa">←</span>
              <span className="back-texta">Back</span>
            </div>
            <ul>
              <li className={location.pathname === '/homepage' ? 'active-nav' : ''}>
                <Link to="/homepage">Home</Link>
              </li>
              <li className={location.pathname === '/homepage/buy-packs' ? 'active-nav' : ''}>
                <Link to="/homepage/buy-packs">Buy Packs</Link>
              </li>
              <li className={location.pathname === '/homepage/about-us' ? 'active-nav' : ''}>
                <Link to="/homepage/about-us">About Us</Link>
              </li>
            </ul>
          </div>

          <div className="nav-right">
            {isAuthenticated ? (
              <>
                <div className="user-tokens-wrapper">
                  <span className="username">👋 Hi, {username}</span>
                  <span className="tokens" onClick={handleBuyMoreTokens}>
                    <FaHome className="house-icon" /> {tokens === null ? 'Loading...' : tokens}
                  </span>
                </div>

                <Link to="/homepage/profile" className="profile-button">
                  <span className="material-icons">account_circle</span>
                  <span className="profile-label">Profile</span>
                </Link>
              </>
            ) : (
              <>
                <Link to="/signin" className="signin">
                  Sign In
                </Link>
                <Link to="/register" className="signup">
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </nav>
      </div>

      {/* Animated Page */}
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.4, ease: 'easeInOut' }}
          style={{
            overflowX: 'hidden',
            backgroundColor: '#fff',
            minHeight: 'calc(100vh - 70px)',
            padding: '10px 0',
          }}
        >
          <Outlet context={{ tokens, addTokens, addingTokens }} />
        </motion.div>
      </AnimatePresence>
    </>
  );
}

export default Layout;
